import _ from 'lodash';

export function toUrlParams(data: {} | undefined = {}): string {
  return _.chain(data)
    .keys()
    .filter(
      (k) => _.isNumber(data[k]) || !_.isEmpty(data[k]) || data[k] === true,
    )
    .map((key) => `${key}=${encodeURIComponent(data[key])}`)
    .join('&')
    .value();
}
